import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useComponentClassName } from "../../../auxiliary/useComponentClassName.js";
import { toEnumViewClass } from "../../../utils/toEnumViewClass.js";
const ButtonList = memo(({ children, flow, orientation, size }) => /* @__PURE__ */ jsx("div", { className: classNames(
  useComponentClassName("button-list"),
  toEnumViewClass(size),
  toEnumViewClass(orientation, "horizontal"),
  toEnumViewClass(flow, "inline")
), role: "group", children }));
ButtonList.displayName = "ButtonList";
export {
  ButtonList
};
//# sourceMappingURL=ButtonList.js.map
